import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SelectItem, Table } from 'primeng';
import { AccessUserInfo, LabRequest, UserDetail, UserLocationFacility } from 'src/app/models';
import { CustomDialogService, FacilityService, LabRequestService, UserService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';
import { CreateLabRequestComponent } from '../create-lab-request/create-lab-request.component';
import { LabRequestHistoryComponent } from '../lab-request-history/lab-request-history.component';
import { PreviewLabelComponent } from '../preview-label/preview-label.component';
import { DialogService } from 'primeng/dynamicdialog';
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { WorkFlow } from 'src/app/enum/water-lab/workFlow';
@Component({
  selector: 'bart-lab-requests',
  templateUrl: './lab-requests.component.html',
  styleUrls: ['./lab-requests.component.scss'],
  providers: [DialogService, CustomDialogService]
})
export class LabRequestsComponent implements OnInit {
  @ViewChild('dtRequestTable', { static: false }) dtRequests: Table;
  filteredRequests: LabRequest[] = [];
  requestColumnHeader: any[];
  seletedRequestData: LabRequest[] = []; mySubscription: any;
  ;
  facilityList: SelectItem[] = [];
  userLocationFacilities: UserLocationFacility[] = [];
  isHeaderCheckBoxChecked: boolean = false;
  selectedFacilityMasterId?: number = null;
  public userInfo: UserDetail;
  isShowPreviewLabel:boolean=false;
  locationModality:string="";
  haveMultiworkflow:boolean=false;
  constructor
    (
      private _labRequest: LabRequestService,
      private _loaderService: LoaderService,
      public dialogService: CustomDialogService,
      private _facilityService: FacilityService,
      private router: Router,
      private _userService: UserService

    ) { }

  ngOnInit() {
    this.userInfo = AccessUserInfo.getUserInfo();
    this.selectedFacilityMasterId= AccessUserInfo.getSelectedFacilityMasterId()
    this.requestColumnHeader = [
      { field: 'LabRequestID', header: 'Request ID', display: 'table-cell', width: "8%" },
      { field: 'EquipmentDisplayName', header: 'Model # | Nickname | Serial # | Equipment ID ' },
      { field: 'EquipmentDescription', header: 'Equipment Description', display: 'table-cell' },
      { field: 'RequestWorkFlow', header: 'Workflow ', width: "8%"},
      { field: 'LabType', header: 'Type of Lab', display: 'table-cell', width: "10%" },
      { field: 'Frequency', header: 'Frequency', display: 'table-cell', width: "7%" },
      { field: 'Status', header: 'Status', display: 'table-cell', width: "8%" },
    ];
    this.GetUserLocations((callBack) => {
      this.facilityChanged();
    });

    this._labRequest.event.subscribe(data => {
      if (data) {
        this.loadRequests();
      }
    });


  }
  loadRequests() {

    this._loaderService.show()
    let getLabRequestParam = {
      "GETLABREQUEST": {
        FacilityMasterID: this.selectedFacilityMasterId//this.facilityList.map(x => x.value).join(","),
      },
    }
    this.resetTable();
    this.filteredRequests = [];
    this._labRequest.getLabRequests(JSON.stringify(getLabRequestParam)).subscribe(data => {
      this.filteredRequests = data.labRequestResults;
      this.filteredRequests.forEach(item => {
        item.LabTests = JSON.parse(item.labTestsJson)
      });
      this._loaderService.hide()
      this.locationModality=this.userLocationFacilities.find(x=>x.FacilityMasterID==this.selectedFacilityMasterId).LocationModality
    },
      err => {
        this.filteredRequests = [];
        this._loaderService.hide()
      });



  }
  openHistoryPopup(labRequestId, facilityMasterId) {
    const ref = this.dialogService.open(LabRequestHistoryComponent, {
      header: 'Lab Request History',
      width: '90%',
      styleClass:'lab-request-history-model-popup',
      data: { labRequestId: labRequestId, facilityDisplayName: this.facilityList.find(x => x.value == facilityMasterId).label,selectedFacilityMasterId:this.selectedFacilityMasterId,userLocationFacilities:this.userLocationFacilities }

    });
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.LABREQUEST,
      screenPath: location.pathname,
      key: "LabRequestID",
      value: labRequestId,
      eventDescription:UserActionDescription.LABREQUEST_HISTORY_ICON_CLICKED
    });
    //#endregion
  }
  openEditLabRequestPopup(rowData) {
    const ref = this.dialogService.open(CreateLabRequestComponent, {
      header: 'Lab Request',
      width: '70%',
      data: { labRequestRowData: rowData }
    });
    ref.onDestroy.subscribe((data) => 
    {
      if(this.seletedRequestData)
      {
        this.seletedRequestData=this.seletedRequestData.filter(x => x.Status != 'Inactive');
      }
      this.showPreviewLabel();
    });
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.LABREQUEST,
      screenPath: location.pathname,
      key: "LabRequestID",
      value: rowData.LabRequestID,
      eventDescription:UserActionDescription.LABREQUEST_EDIT_ICON_CLICKED
    });
    //#endregion
  }
  openPreviewLabelPopup() {
    const ref = this.dialogService.open(PreviewLabelComponent, {
      header: this.seletedRequestData[0].RequestWorkFlow==WorkFlow.HOME?'Home Label Summary':'Label Summary',
      styleClass:"preview-label-summary-popup",
      data:
      {
        labRequestId:this.seletedRequestData.map(x => x.LabRequestID).join(","),
        facilityMasterId:this.selectedFacilityMasterId,
        facilityDisplayName:this.facilityList.find(x=>x.value==this.selectedFacilityMasterId).label,
        workFlow:this.seletedRequestData[0].RequestWorkFlow,
      }
    });
    ref.onClose.subscribe((data) => 
    {
      if(data && data.result && !data.isSuccess){
        this.router.navigate(["/WaterLab/ShippingManifest"]);
      }
      this.facilityChanged();
    });
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.BUTTON_CLICKED,
      screenName: ScreenName.LABREQUEST,
      screenPath: location.pathname,
      key: "LabRequestID",
      value: this.seletedRequestData.map(x => x.LabRequestID).join(","),
      eventDescription:UserActionDescription.LABREQUEST_PREVIEW_LABEL_BUTTON_CLICKED
    });
    //#endregion
  }
  private GetUserLocations(callBack) {
    this._loaderService.show();
    this.facilityList = [];
    let getLocationParam =
    {
      "GETUSERLOCATIONS":
      {
        LOCATION_ID_LIST: null,
        USERNAME: this.userInfo.userName,
      },
      "GETUSERLOCATIONS2":
      {
        USERNAME: this.userInfo.userName,
      }
    }
    if (getLocationParam != null) {
      this._facilityService.getUserLocations(JSON.stringify(getLocationParam))
        .subscribe((resp: any) => {
          if (resp.facilities) {
            this.userLocationFacilities=resp.facilities
            this.facilityList = this.userLocationFacilities.filter(x=>x.LocationModality && x.LocationModality.length>0).map(data => ({
              label: data.FacilityDisplayName,
              value: data.FacilityMasterID,
            }));
            if (this.facilityList && this.facilityList.length && this.selectedFacilityMasterId==null) {
              this.selectedFacilityMasterId = this.facilityList[0].value;
            }
            this._loaderService.hide();
            callBack();
          }
          else {
            this._loaderService.hide();
          }

        },
          (error) => {
            this._loaderService.hide();
            this.facilityList = [];
          });
    }
  }
  facilityChanged() {

    AccessUserInfo.setSelectedFacilityMasterId(this.selectedFacilityMasterId.toString())
    this._labRequest.selectedFacility.next(this.selectedFacilityMasterId)
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.FILTER,
      screenName: ScreenName.LABREQUEST,
      screenPath: location.pathname,
      key: "FacilityMasterID",
      value: this.selectedFacilityMasterId,
      eventDescription:UserActionDescription.LABREQUEST_FACILITY_CHANGED
    });
    //#endregion
    
    this.loadRequests();
  }
  headerCheckBoxChecked() {

    let pageOfItems = this.filteredRequests ? this.filteredRequests.slice(this.dtRequests.first, (this.dtRequests.first + this.dtRequests.rows)) : [];
    if(this.dtRequests.filteredValue)
    {
      pageOfItems=this.dtRequests.filteredValue.slice(this.dtRequests.first, (this.dtRequests.first + this.dtRequests.rows));
    }
    if (this.isHeaderCheckBoxChecked) {
      let activeObj = pageOfItems.filter(x => x.Status != 'Inactive');
      this.seletedRequestData = this.seletedRequestData.concat(activeObj);

    }
    else {
      let activeObj = pageOfItems.filter(x => x.Status != 'Inactive');
      this.seletedRequestData = this.seletedRequestData.filter(ar => !activeObj.find(rm => (rm.LabRequestID === ar.LabRequestID)))
    }
    this.showPreviewLabel();
  }
  rowCheckBoxChecked() {
    this.manageCheckBoxSelection()
    this.showPreviewLabel();
  }
  manageCheckBoxSelection() {

    let pageOfItems = this.filteredRequests ? this.filteredRequests.slice(this.dtRequests.first, (this.dtRequests.first + this.dtRequests.rows)) : [];
    if(this.dtRequests.filteredValue)
    {
      pageOfItems=this.dtRequests.filteredValue.slice(this.dtRequests.first, (this.dtRequests.first + this.dtRequests.rows));
    }
    let activeObjA = pageOfItems.filter(x => x.Status != 'Inactive');
    let activeObjB = this.seletedRequestData.filter(ar => activeObjA.find(rm => (rm.LabRequestID === ar.LabRequestID)))
    if (activeObjA.length == activeObjB.length && activeObjA.length > 0) {
      this.isHeaderCheckBoxChecked = true;

    }
    else {
      this.isHeaderCheckBoxChecked = false;
    }
  }
  paginate(event) {

    this.manageCheckBoxSelection()
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.PAGE_CHANGED,
      screenName: ScreenName.LABREQUEST,
      screenPath: location.pathname,
      key: 'Selected_Page_No',
      value: (event.first / event.rows) + 1,
      eventDescription:UserActionDescription.LABREQUEST_PAGE_NO_CLICKED
    });
    //#endregion
  }
  resetTable(isTableReset:boolean=true) {
    if (this.dtRequests && isTableReset) {
      this.dtRequests.reset();
    }
    this.seletedRequestData = [];
    this.isHeaderCheckBoxChecked = false;
    this.showPreviewLabel();
  }
  onFilter(event)
  {
    this.resetTable(false);
  }
  sortColumn(event) {
    
    this.resetTable(false)
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.SORT,
      screenName: ScreenName.LABREQUEST,
      screenPath: location.pathname,
      key: event.field,
      value: event.order === 1 ? 'ASC' : 'DESC',
      eventDescription:UserActionDescription.LABREQUEST_COLUMN_SORT
    });
    //#endregion
  }
 
  showPreviewLabel()
  {
    
    this.isShowPreviewLabel=false
    if(this.seletedRequestData && this.seletedRequestData.length)
    {
      let distinct = this.seletedRequestData.filter((x, i, arr) => arr.findIndex(t => t.Frequency === x.Frequency && t.RequestWorkFlow===x.RequestWorkFlow) === i);
      if(distinct && distinct.length==1)
      {
        this.isShowPreviewLabel=true
      }
    }
    else
    {
      this.isHeaderCheckBoxChecked=false;
    }
    this.checkMultiWorkFlowSelection();
  }
   
  checkMultiWorkFlowSelection(){
    this.haveMultiworkflow = false;
    if(this.seletedRequestData && this.seletedRequestData.length)
    {
      let distinct = this.seletedRequestData.filter((x, i, arr) => arr.findIndex(t => t.RequestWorkFlow === x.RequestWorkFlow) === i);
      if(distinct && distinct.length>1)
      {
        this.haveMultiworkflow=true;
      }
    }
  }
}
